// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221525/js/" + chunkId + "." + {"44":"b0995d5a","225":"2285c4c0","481":"93f43272","486":"94e4aa43","770":"4bc203c5"}[chunkId] + ".0.804171337667329.chunk.js";
};